import {
  Button,
  Separator,
  TextCaption,
  TextSubHeader,
} from '@carboncopyco/ui';
import { openLinkInBrowser } from '../../../../util/path-util';

interface HeaderBlockProps {
  label: string;
  description: string;
  learnMoreLink?: string;
}

export const HeaderBlock = ({
  label,
  description,
  learnMoreLink,
}: HeaderBlockProps) => (
  <div className="flex flex-col gap-6 pb-8">
    <div className="flex flex-col gap-1">
      <TextSubHeader
        label={label}
        color="text-ds-natural-600"
      />
      <div className="w-full items-center">
        <TextCaption label={description} />
        {learnMoreLink && (
          <Button
            className="text-sm text-ds-natural-300 underline"
            onClick={() => openLinkInBrowser(null, learnMoreLink)}
          >
            learn more
          </Button>
        )}
      </div>
    </div>
    <Separator horizontal />
  </div>
);
